<!-- <div class="header-popup">
  <button class="btn-close themeComparePopupCloseButton1" mat-mini-fab (click)="closeDialog('')">X</button>
</div>
<div>
  <div class="layout">
    <img [src]="replaceBucket.replaceBucket(urlImg())" alt="" />
  </div>
</div> -->
<div class="header-popup">
  <button class="btn-close themeComparePopupCloseButton1" mat-mini-fab (click)="closeDialog('')">X</button>
</div>
<div>
  <div class="layout">
    <!-- <img [src]="replaceBucket.replaceBucket(urlImg())" alt="" /> -->

    <owl-carousel-o [options]="carouselOptions">
      @for( img of this.urlImg(); track i ; let i = $index ){

      <ng-template carouselSlide>
        <img [src]="replaceBucket.replaceBucket(img)" alt="รูปภาพแกลเลอรี่" title="รูปภาพแกลเลอรี่" loading="lazy" />
      </ng-template>
      }
    </owl-carousel-o>
  </div>
</div>
